import { cn } from '@tripleten/cn';

export const cnFlex = cn('flex');
